import { rtkAPI } from 'rtk/rtkSetup';
import api from 'util/api';

export const JOURNAL_REPO_TAGS = {
  LIST: 'RepositorySigning'
};

const enhancedApi = rtkAPI.enhanceEndpoints({
  addTagTypes: [JOURNAL_REPO_TAGS.LIST]
});

export const journalRepoApi = enhancedApi.injectEndpoints({
  endpoints: build => ({
    listRepositorySigningsByUser: build.query({
      async queryFn(params) {
        // An empty userGuid lists signings across every connected notary.
        try {
          const res = await api.RepositorySignings.listByUserGuid(params);
          return { data: res };
        } catch (error) {
          return { error };
        }
      },
      providesTags: (result, error, { userGuid }) => [
        { type: JOURNAL_REPO_TAGS.LIST, id: userGuid || 'ALL' }
      ]
    })
  })
});

export const {
  useListRepositorySigningsByUserQuery,
  useLazyListRepositorySigningsByUserQuery
} = journalRepoApi;
